import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';

// Pages
import { InstructorAddEditPage } from '../../pages/instructors/instructor-add-edit';

// Providers
import { InstructorsService } from '../../providers/instructors/instructors-service';

// Helpers
import { HelperCsvService } from '../../providers/helpers/helper-csv-service';

import moment from 'moment';

@Component({
  selector: 'page-report-certifications-date-range',
  templateUrl: 'report.certifications-date-range.html'
})

export class ReportCertificationStatusDateRangePage {
  headerData: any;
  reportStartDate: string = '';
  reportEndDate: string = '';
  gotRecords: boolean = false;
  instructorsExpiring: any = [];
  instructorsRecertification: any = [];
  instructorsNewCertification: any = [];
  instructorsRejectedCertification: any = [];

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public instructorsService: InstructorsService,
    public helperCsvService: HelperCsvService
  ) {
    this.headerData = { title: 'Certification Status by Date Range' };
  }

  createReport()
  {
    this.instructorsService.getInstructorsApplicationStatusDateRange( this.reportStartDate, this.reportEndDate )
      .subscribe( data => {
        console.log(data);
        this.instructorsExpiring = data[0];
        this.instructorsNewCertification = data[1];
        this.instructorsRecertification = data[2];
        this.instructorsRejectedCertification = data[3];

        this.compareExpiringRenewed();

        if ( data.length > 0 )
        {
          this.gotRecords = true;
        } else {
          console.log('No records found.')
        }
      });
  }

  compareExpiringRenewed()
  {
    // Compare expired certs with renewed certs.
    // If an instructor renewed ON or BEFORE their cert expired, 
    // then we don't want them listed as Expired.
    let count = 0;

    let i = this.instructorsExpiring.length;
    while ( i-- )
    {
      for ( let j of this.instructorsRecertification )
      {
        if ( this.instructorsExpiring[i].instructor_id === j.instructor_id )
        {
          // Let's do a compare. We may need to change this to just isBefore.
          if ( moment( j.date_renewed ).isSameOrBefore( this.instructorsExpiring[i].date_expire ) )
          {            
            // Remove instructor from EXPIRED list.
            this.instructorsExpiring.splice( i, 1 );
          }
        } 
      }
    }
  }

  showInstructorAddEditPage( instructor = null )
  {
    this.navCtrl.push( InstructorAddEditPage, {
      instructor: instructor
    });
  }

  createReportCSV()
  {
    this.helperCsvService.exportInstructorList( this.instructorsExpiring, 'Exiring Instructor List.csv' );
    this.helperCsvService.exportInstructorList( this.instructorsNewCertification, 'New Certification Instructor List.csv' );
    this.helperCsvService.exportInstructorList( this.instructorsRecertification, 'Renewed Certification Instructor List.csv' );
  }
}


// WEBPACK FOOTER //
// ./src/pages/reports/report.certifications-date-range.ts